import React, { useEffect } from "react";

/**
 * Popup landing page for the GitHub OAuth web flow.
 *
 * GitHub redirects the popup window here with `?code=...&state=...`.
 * We hand the code back to the window that opened the popup via postMessage,
 * then close ourselves. The opener (OAuthButtons) verifies `state` and
 * exchanges the code with our backend.
 */
export default function GithubCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const error = params.get("error_description") || params.get("error");

    const payload = { source: "scopuz-github-oauth", code, state, error };

    if (window.opener) {
      window.opener.postMessage(payload, window.location.origin);
      window.close();
    }
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: "#000000" }}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-primary/30 border-t-primary rounded-full animate-spin" />
        <p className="text-xs font-medium" style={{ color: "var(--primary)" }}>
          Finishing GitHub sign-in…
        </p>
      </div>
    </div>
  );
}
